import React, {Component} from 'react'
import Header from './Header'
import Main from './Main'
import Footer from './Footer';
import { init as firebaseInit, 
    // addProduct, getProducts
} from '../utils/firebase'

class App extends Component{
    
    constructor(props) {
        super(props)
        firebaseInit()

        // addProduct(
        //     'Cover Pot Kayu Uk 10', 
        //     'Diameter Atas 13,5 cm<br>Diameter Bawah 10 cm<br>Tinggi : 12 cm', 
        //     '20000',
        //     '10', 
        //     'Furniture', 
        //     "https://bandungjualan.files.wordpress.com/2015/09/img_20150923_202330_post.jpg?w=634&h=357", 
        //     [
        //         'https://bandungjualan.files.wordpress.com/2015/09/img_20150923_202330_post.jpg?w=634&h=357',
        //         'https://bandungjualan.files.wordpress.com/2015/09/img_20150923_202330_post.jpg?w=634&h=357',
        //         'https://bandungjualan.files.wordpress.com/2015/09/img_20150923_202330_post.jpg?w=634&h=357',
        //         'https://bandungjualan.files.wordpress.com/2015/09/img_20150923_202330_post.jpg?w=634&h=357'
        //     ]
        // )
        // getProducts().then((querySnapshot) => {
        //     querySnapshot.forEach((doc) => {
        //         console.log(`${doc.id}`);
        //         console.log(doc.data());
        //     });
        // })
    }

    render(){
        return(
            <div>
                <Header />
                <Main />
                <Footer />
            </div>
        );
    }
}

export default App


// WEBPACK FOOTER //
// ./src/containers/App.jsx